import * as a from "react";
const e = (l) => /* @__PURE__ */ a.createElement(
  "svg",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...l
  },
  /* @__PURE__ */ a.createElement(
    "path",
    {
      d: "M3 4a1 1 0 011-1h6.775a1 1 0 110 2H5v6a1 1 0 11-2 0V4zM19.696 3.232c.38-.007.597-.01.84.232l.026.03c.204.18.335.443.34.735l.04 5.617a.976.976 0 01-.977.846l-.122-.008c-.44-.057-.8-.403-.867-.852l-.034-3.36-4.063 4.064a1 1 0 01-1.415-1.415l3.92-3.92-3.089-.022.014-.014a1.007 1.007 0 01-.979-.453.993.993 0 01-.008-1.073.979.979 0 01.973-.44l5.184.036c.078 0 .15-.002.217-.003zM4.304 20.768c-.38.007-.597.01-.84-.232a.317.317 0 01-.026-.03 1.006 1.006 0 01-.34-.735l-.04-5.617a.975.975 0 01.977-.846l.122.008c.44.058.8.403.867.852l.034 3.36 4.063-4.063a1 1 0 011.415 1.414l-3.92 3.92 3.089.022-.014.014c.384-.053.767.124.979.453a.993.993 0 01.008 1.073.979.979 0 01-.973.44l-5.184-.035c-.078 0-.15 0-.217.002zM20 21a1 1 0 001-1v-7a1 1 0 10-2 0v6h-5a1 1 0 100 2h6z",
      fill: "#2d6ded"
    }
  )
), t = e;
export {
  t as default
};
